/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import {
  INVOICE_STATUS_PAID,
  INVOICE_STATUS_PENDING,
  INVOICE_STATUS_UNPAID
} from '../../enums/InvoiceStatusCodes.mjs'
import Filter, { FilterableProps } from '../Filter'
import { Checkbox, Radio } from '@mantine/core'
import useArrayFilter from '../../../../client/js/hooks/useArrayFilter'

function InvoiceStatusFilter (props: FilterableProps<string[]>) {
  const { onChange, value } = props
  const intl = useIntl()
  const [array, handleChange] = useArrayFilter(value, onChange)
  return (
    <Filter>
      <Radio
        checked={array.length === 0}
        id="invoice_status_all_filter"
        label={intl.formatMessage({
          id: 'all',
          defaultMessage: 'Tout'
        })}
        name="status"
        onChange={(event) => {
          if (event.target.checked) {
            onChange(event.target.name, undefined)
          }
        }}
        value=""
      />
      <Checkbox
        checked={array.includes(INVOICE_STATUS_PENDING)}
        id="invoice_status_pending_filter"
        label={intl.formatMessage({
          id: 'pending',
          defaultMessage: 'En attente'
        })}
        name="status"
        onChange={handleChange}
        value={INVOICE_STATUS_PENDING}
      />
      <Checkbox
        checked={array.includes(INVOICE_STATUS_UNPAID)}
        id="invoice_status_unpaid_filter"
        label={intl.formatMessage({
          id: 'unpaid',
          defaultMessage: 'Impayé'
        })}
        name="status"
        onChange={handleChange}
        value={INVOICE_STATUS_UNPAID}
      />
      <Checkbox
        checked={array.includes(INVOICE_STATUS_PAID)}
        id="invoice_status_paid_filter"
        label={intl.formatMessage({
          id: 'paid',
          defaultMessage: 'Payé'
        })}
        name="status"
        onChange={handleChange}
        value={INVOICE_STATUS_PAID}
      />
    </Filter>
  )
}

export default InvoiceStatusFilter
